import { flexRender } from '@tanstack/react-table';
import React, { memo } from 'react';

import { ASCENDING } from '../../../constants/messageConst';

const CustomTableHeader = ({
  headerGroup,
  getFilterComponent,
  setOpenFilterColumnId,
  columns,
  filteredData,
  gridOptionId
}) => {
  return (
    <>
      <tr className="text-center">
        {headerGroup?.map((col, i) => {
          const optionColumns = columns[i];
          const header = col?.column?.columnDef;
          const key = `th-${gridOptionId}-${col.id || i}`;
          return (
            <th
              key={key}
              style={{
                width: header?.size,
                minWidth: header?.minSize,
                maxWidth: header?.maxSize,
                paddingLeft: '6px',
                paddingRight: '6px',
                verticalAlign: 'middle',
                position: 'sticky',
                top: 0,
                zIndex: 2,
                ...optionColumns.headerStyle
              }}
              width={col.getSize()}
            >
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  marginBottom: '0.2rem',
                  marginTop: '0.2rem',
                  alignItems: 'center'
                }}
              >
                <div
                  className={`w-100 text-left ${optionColumns?.headerClassName || ''}`}
                  onClick={e => (header?.customHeaderRenderer ? e.stopPropagation() : '')}
                >
                  {flexRender(
                    header?.customHeaderRenderer
                      ? header.customHeaderRenderer({ ...col, filteredData })
                      : header.Header,
                    col.getContext()
                  )}
                </div>

                <div
                  className="pl-1 clickable"
                  title={
                    col.column.getCanSort()
                      ? col.column.getNextSortingOrder() === 'asc'
                        ? 'Sort ascending'
                        : col.column.getNextSortingOrder() === 'desc'
                        ? 'Sort descending'
                        : 'Clear sort'
                      : undefined
                  }
                  onClick={col.column.getToggleSortingHandler()}
                >
                  {optionColumns.canSort &&
                    (col.column.getIsSorted() ? (
                      col.column.getIsSorted() === ASCENDING ? (
                        <span className="text-dark-100">
                          <i className="fa fa-sort-asc" aria-hidden="true" />
                        </span>
                      ) : (
                        <span className="text-dark-100">
                          <i className="fa fa-sort-desc" aria-hidden="true" />
                        </span>
                      )
                    ) : (
                      <span className="text-dark-100">
                        <i className="fa fa-sort" aria-hidden="true" />
                      </span>
                    ))}
                </div>
              </div>
              <div
                onMouseDown={col.getResizeHandler()}
                onTouchStart={col.getResizeHandler()}
                className={
                  optionColumns?.canStopColumnResize
                    ? ''
                    : `resizer ${col?.column?.getIsResizing() ? 'isResizing' : ''}`
                }
              />
            </th>
          );
        })}
      </tr>

      {columns?.some(x => x.canFilter) ? (
        <>
          <tr>
            {headerGroup?.map((col, i) => {
              const optionColumns = columns[i];
              const key = `tdFilter-${gridOptionId}-${col.id || i}`;
              return (
                <td
                  key={key}
                  className="text-primary pt-0"
                  title={
                    optionColumns?.canFilter
                      ? optionColumns?.filterType === 'text'
                        ? 'Text Filter'
                        : optionColumns?.filterType === 'dropdown'
                        ? 'Dropdown Filter'
                        : optionColumns?.filterType === 'datepicker'
                        ? 'Date Filter'
                        : optionColumns?.filterType === 'numberfilter'
                        ? 'Number Filter'
                        : 'Filter'
                      : ''
                  }
                  onClick={() => {
                    setOpenFilterColumnId(null);
                  }}
                >
                  {optionColumns?.canFilter ? (
                    <div key={`filter-component-${gridOptionId}-${col.id}`}>{getFilterComponent(col)}</div>
                  ) : null}
                </td>
              );
            })}
          </tr>
          <tr className="hrTag">
            <td colSpan={100} className="p-0" />
          </tr>
        </>
      ) : (
        <tr className="hrTag">
          <td colSpan={100} className="p-0" />
        </tr>
      )}
    </>
  );
};

CustomTableHeader.displayName = 'CustomTableHeader';
export default memo(CustomTableHeader);
